import { IField, generateID } from '@eventr/common'
import { Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useEffect, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { IEditComponent } from '../../../data/Data'
import { bs, useBoundStore } from '../../../state/bound.store'
import { ComponentFinderEdit } from '../componentFinderEdit'
import { useEditSectionContext } from '../editSectionProvider'
interface IGroupFieldProps {
    field: IField
    options: IEditComponent
    _id?: string
}

export const GroupField = ({ field, _id, options }: IGroupFieldProps) => {
    const { getValue, section } = useEditSectionContext()
    const { fields } = useBoundStore(
        useShallow((s) => {
            return {
                fields: s.fields,
            }
        })
    )
    const { updateValues } = useEditSectionContext()
    const [state, setState] = useState<string>()
    const [init, setInit] = useState<boolean>(false)
    useEffect(() => {
        if (init) return
        const selectedItinID = bs().selectedItinID
        const initFieldValue = getValue(field, _id)
        if (initFieldValue._id) {
            setState(initFieldValue._id)
        } else {
            const newId = generateID(selectedItinID, section.id, field.id)
            const value = { _id: newId }
            updateValues({ field: field, value: value, _id: _id })
            setState(newId)
        }

        setInit(true)
    }, [field, _id, getValue, init, setInit])

    const componentsToRender = () => {
        if (options.components) {
            return options.components
        } else {
            return []
        }
    }
    return (
        <Stack spacing={'16px'}>
            {componentsToRender().map((option: any, index: number) => {
                const fieldInfo = fields?.find((field: IField) => {
                    return field.id === option.fieldId
                })

                if (fieldInfo && fieldInfo.field_type) {
                    return (
                        state && (
                            <ComponentFinderEdit
                                key={index}
                                _id={state}
                                editComponent={option}
                            />
                        )
                    )
                } else {
                    return <Typography key={index}>Field info wrong</Typography>
                }
            })}
        </Stack>
    )
}
